import {
  BatchReminderPostcardConditionListItem,
  BatchReminderListConditionPostcardItemFromJSON
} from '@/api/models/batch/BatchReminderPostcardConditionListItem'

export interface BatchReminderPostcardPageLoadResult {
  items: BatchReminderPostcardConditionListItem
}

export function BatchReminderPostcardPageLoadResultFromJSON(
  json: any
): BatchReminderPostcardPageLoadResult {
  return {
    items: BatchReminderListConditionPostcardItemFromJSON(json)
  }
}
